export const MAX_MESSAGES = 100;
export const WARNING_THRESHOLD = 90;
export const GENERIC_ERROR_MESSAGE = 'Si è verificato un errore. Riprova tra qualche istante.';
